(function () {
  function bindMq(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  function unbindMq(mq, fn) {
    if (mq.removeEventListener) mq.removeEventListener('change', fn);
    else if (mq.removeListener) mq.removeListener(fn);
  }

  function init(root) {
    if (!root || root.dataset.vxInit === '1') return;
    root.dataset.vxInit = '1';

    let video = root.querySelector('.vx-story__video');
    let motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let narrow = window.matchMedia('(max-width: 767px)');
    let editor = !!(window.Shopify && window.Shopify.designMode);
    let observers = [];

    function showCopy() {
      root.classList.add('is-in');
    }

    function currentSrc() {
      if (!video) return '';
      let mobileSrc = video.getAttribute('data-src-m') || '';
      let desktopSrc = video.getAttribute('data-src-d') || '';
      if (narrow.matches && mobileSrc) return mobileSrc;
      return desktopSrc || mobileSrc;
    }

    function activate() {
      if (!video || motion.matches) return;
      let next = currentSrc();
      if (!next) return;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      if (video.getAttribute('data-loaded') !== next) {
        video.pause();
        root.classList.remove('is-playing');
        video.setAttribute('data-loaded', next);
        video.src = next;
      }
      let playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function deactivate() {
      if (!video) return;
      video.pause();
    }

    function onPlaying() {
      root.classList.add('is-playing');
    }

    function onMq() {
      if (motion.matches || root.getAttribute('data-vx-seen') !== '1') return;
      activate();
    }

    function onMotion() {
      if (motion.matches) {
        root.classList.remove('is-playing');
        if (video) {
          video.removeAttribute('src');
          video.removeAttribute('data-loaded');
          video.pause();
        }
        showCopy();
        return;
      }
      if (root.getAttribute('data-vx-seen') === '1') activate();
    }

    if (editor || motion.matches || !('IntersectionObserver' in window)) {
      showCopy();
    } else {
      let copyIo = new IntersectionObserver(
        function (entries) {
          if (!entries[0] || !entries[0].isIntersecting) return;
          showCopy();
          copyIo.disconnect();
        },
        { threshold: 0.2 }
      );
      copyIo.observe(root);
      observers.push(copyIo);
    }

    if (video) {
      video.addEventListener('playing', onPlaying);
      bindMq(narrow, onMq);
      bindMq(motion, onMotion);

      if (!motion.matches) {
        if (!('IntersectionObserver' in window)) {
          root.setAttribute('data-vx-seen', '1');
          activate();
        } else {
          let videoIo = new IntersectionObserver(
            function (entries) {
              let entry = entries[0];
              if (!entry) return;
              if (entry.isIntersecting) {
                root.setAttribute('data-vx-seen', '1');
                activate();
              } else {
                deactivate();
              }
            },
            { rootMargin: '200px 0px' }
          );
          videoIo.observe(root);
          observers.push(videoIo);
        }
      }
    }

    root._vxStoryDestroy = function () {
      let i;
      for (i = 0; i < observers.length; i++) observers[i].disconnect();
      unbindMq(narrow, onMq);
      unbindMq(motion, onMotion);
      if (video) {
        video.removeEventListener('playing', onPlaying);
        video.pause();
      }
    };
  }

  function boot(scope) {
    let node = scope || document;
    if (!node.querySelectorAll) return;
    let roots = node.querySelectorAll('[data-vx-story]');
    let i;
    for (i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (!window.__vxStoryListeners) {
    window.__vxStoryListeners = true;
    document.addEventListener('shopify:section:load', function (event) {
      let scope = event.target;
      if (!scope || !scope.querySelectorAll) return;
      let roots = scope.querySelectorAll('[data-vx-story]');
      let i;
      let root;
      for (i = 0; i < roots.length; i++) {
        root = roots[i];
        if (root._vxStoryDestroy) root._vxStoryDestroy();
        delete root.dataset.vxInit;
        init(root);
      }
    });
    document.addEventListener('shopify:section:unload', function (event) {
      let scope = event.target;
      if (!scope || !scope.querySelector) return;
      let root = scope.querySelector('[data-vx-story]');
      if (root && root._vxStoryDestroy) root._vxStoryDestroy();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }
})();
